import React from 'react';
import styled from 'styled-components';

const StepIndicatorContainer = styled.div`
  display: flex;
  justify-content: center;

  & > div {
    width: 50px;
    height: 6px;
    margin: 0 5px;
  }
`;

const StepItem = styled.div`
  background-color: ${(props) =>
    props.$myIndex <= props.$step ? '#B34CFF' : '#ccc'};
`;

export const StepIndicator = ({ step }) => {
  const totalSteps = 3;
  return (
    <StepIndicatorContainer>
      {Array.from({ length: totalSteps }).map((_, index) => (
        <StepItem key={index} $myIndex={index + 1} $step={step} />
      ))}
    </StepIndicatorContainer>
  );
};
